<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible"   style="width:600px;margin:auto;" @close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="80px" >
      <div class="modal-body scrollContainer" ref="scrollContainer">
        <div class="chat-message" v-for="(message,index)  in records" :key="index">
              <div  v-if="message.isAnswer" class="message-sender-left">                     
                <img v-if="message.supplierLogo" :title="message.supplierName" :src="message.supplierLogo">
                <img v-else :title="message.supplierName" src="https://file-sz.fjjykj.com.cn/Supply/sbc66de876f0ec3f951eaeab89ad80afb.png">
              </div>           
              <div v-if="message.isAnswer" class="message-content-left">
                 <span v-html="message.content"></span><br/>
                 <span class="sendTime">{{ message.addTime |formatDateTime }}</span>
              </div>   
              <div v-if="!message.isAnswer" class="message-sender-right">
                <img v-if="message.userLogo" title="我" :src="message.userLogo">
                <img v-else title="我" src="https://file-sz.fjjykj.com.cn/Supply/sbc66de876f0ec3f951eaeab89ad80afb.png">
              </div>                        
              <div v-if="!message.isAnswer" class="message-content-right">
                <span v-html="message.content"></span>
                <br/>
                 <span class="sendTime">{{ message.addTime |formatDateTime }}</span>
              </div>                    
            </div>
          </div>  
    </el-form>
    <div slot="footer"  v-loading="loading" :element-loading-text="elementLoadingText" class="modal-footer dialog-footer">
      <el-row>
        <el-col :span="1" title="上传图片">
          <el-upload
              :action="aLiction" 
              :http-request="uploadALiFile"
              :before-upload="beforeAvatarUpload"
              class="avatar-uploader"
              :show-file-list="false"
              multiple            
            >
              <img class="uploadImage" src="https://file-sz.fjjykj.com.cn/Supply/sbddac806328e1be05770a03e26663f8a.jpeg">
            </el-upload>
        </el-col>
      </el-row>
     <el-row>
      <el-col :span="21">
        <div ref="sendMsg" class="sendMsg" @input="updateContent" contenteditable="true" v-on:paste="handlePaste">
        </div>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="save">发送</el-button>
      </el-col>
     </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { getCounsellings, counsellingAsk } from '@/api/order'
import { getALiUploadToken, uploadALiFile } from '@/api/commonLookup'
export default {
  name: 'TableEdit',
  data() {
    return {
      form: {
        supplierId:0,
        content:'',
        isSaasUser:false,
      },         
      title: '',
      aLiction:'',
      dialogFormVisible: false,
      loading:false,     
      records:[],
      total:0,
      time:'',
      elementLoadingText:"数据提交中,请稍后...",
      queryForm: {
        MaxResultCount: 1000,
        SkipCount: 0,
        UserId: 0
      },
    }
  },
  beforeDestroy()
  {     
      window.clearTimeout(this.time);
  },
  created() {    
  },
  methods: {
    async show(row) {     
      this.records = [];
      this.total = 0;
      this.title = '咨询-'+ row.supplierName;    
      this.form.supplierId = row.supplierId;  
      this.form.isSaasUser = false;     
      this.queryForm.UserId = row.supplierId;
      this.fetchData();
      this.dialogFormVisible = true;
      var _this=this;
      this.time = window.setInterval(function () {
         _this.fetchData()
        }, 5000)        
    },
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  
        const isLt20M = file.size / 1024 / 1024  < 20
     
        if (!isJPG) {
          this.$message.error('上传文件类型只能是图片(jpg,png,jpeg) 格式!')
        }
        if (isJPG&&!isLt20M) {
          this.$message.error('上传图片大小不能超过 20M!')
        }       
        return (isJPG && isLt20M)
      },  
      
    //上传文件到阿里
    async uploadALiFile(upload) {                    
      this.uploadFileALi1(upload)
    },
    async uploadFileALi1(upload)
    {      
      this.loading=true;
      var _this=this;
      await getALiUploadToken().then(ret => {     
        debugger      
        if(ret.data&& ret.data.success)
        {
          var tempRes = ret.data.result;
          this.aLiction=  tempRes.host;
          this.loading = true;      
          const formData = new FormData() // 创建FormData对象     
          let arrB= upload.file.name.split('.');
          let suffix = '.' + arrB[arrB.length-1];  
          var filename = "s" + this.guidShort() + suffix;           
          var tempMediaType=0;
          if(suffix.indexOf('mp4')>-1||suffix.indexOf('MP4')>0)tempMediaType=1;
          if(suffix.indexOf('mp3')>-1||suffix.indexOf('MP3')>0)tempMediaType=2;
          var url = tempRes.aliDomain + tempRes.dir + filename;
          try{        
          // 添加相关上传参数
            formData.append('key', tempRes.dir + filename);
            formData.append('policy', tempRes.policy);
            formData.append('OSSAccessKeyId', tempRes.accessid);
            formData.append('success_action_status', '200');
            formData.append('signature', tempRes.signature);         
            formData.append('file', upload.file) 

            uploadALiFile(this.aLiction, formData).then((res) => {              
              _this.loading = false
                if(res.status==200)
                {                 
                  var editorContent = _this.$refs.sendMsg.innerHTML   
                   editorContent = editorContent+"<img src="+url +" />";              
                   _this.$refs.sendMsg.innerHTML = editorContent     
                   _this.form.content = editorContent;      
                }
             }).catch((err) => { 
              debugger;
              _this.loading = false
             })          
          }
          catch(ex) { debugger; }
        } 
        else{ 
           this.loading=false;
           this.$message.error('获取阿里token失败!') 
           }
      }) 
    },
    updateContent(event) {
      this.form.content  = event.target.innerHTML;
    },
    handlePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      if (clipboardData) {
        for (let i = 0; i < clipboardData.items.length; i++) {
          const item = clipboardData.items[i];
          if (item.kind === 'file' && item.type.startsWith('image/')) {        
            const file = item.getAsFile();
            const reader = new FileReader();
            reader.onload = (e) => {
              const base64 = e.target.result;
              console.log(base64); // 这里打印出图片的Base64编码
              debugger
              this.uploadFileALi(file,base64);
            };
            reader.readAsDataURL(file);         
          }
        }
      }
    },

    async uploadFileALi(file, tempGuid)
    {    
      this.loading=true;
      var _this=this;    
      await getALiUploadToken().then(ret => {           
        if(ret.data&&ret.data.success)
        {
          debugger;
          var tempRes = ret.data.result;
          var aLiction=  tempRes.host;
          const formData = new FormData() // 创建FormData对象     
          let arrB= file.type.split('/');
          let suffix = '.' +  arrB[arrB.length-1];  
          var filename = "s" + this.guidShort() + suffix;  
          var url = tempRes.aliDomain + tempRes.dir + filename;
        
          try{        
          // 添加相关上传参数
            formData.append('key', tempRes.dir + filename);
            formData.append('policy', tempRes.policy);
            formData.append('OSSAccessKeyId', tempRes.accessid);
            formData.append('success_action_status', '200');
            formData.append('signature', tempRes.signature);         
            formData.append('file', file) 

           uploadALiFile(aLiction, formData).then((res) => {             
                if(res.status==200)
                {                             
                  var editorContent = _this.$refs.sendMsg.innerHTML   
                   editorContent = editorContent.replace(tempGuid, url);              
                   _this.$refs.sendMsg.innerHTML = editorContent     
                   _this.form.content = editorContent; 
                   _this.loading = false                    
                }
             }).catch((err) => { 
              debugger;
              _this.loading = false
             })          
          }
          catch(ex) { debugger; }
        } 
        else{ 
           this.loading=false;
           this.$message.error('获取阿里token失败!') 
           }
      }) 
    },
    //GUID生成
    guidShort() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (S4() + S4() + "" + S4() + "" + S4() + "" + S4() + "" + S4() + S4() + S4());
    },

    async fetchData() {    
      const result = await getCounsellings(this.queryForm)       
      if(result.data.result.totalCount!=this.total)
      {
        this.total = result.data.result.totalCount;
        this.records = result.data.result.items; 
        setTimeout(() => {
                this.scrollToBottom();
              }, 100);
      }    
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer;     
      container.scrollTop = container.scrollHeight;
    },
  
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
      window.clearTimeout(this.time);
    },
    save() {       
      this.$refs.sendMsg.innerHTML = '';     
      counsellingAsk(this.form).then(res=>{
        this.form.content='';    
        this.fetchData();
      });     
    },  
 
  },
}
</script>
<style>
.modal-body 
{
   width: 580px;
   max-height: 350px;
   min-height: 350px;
   overflow: auto;
}

.modal-body .chat-message {
  padding: 10px;
  margin: 10px 0;
  min-height: 45px;
  background-color: #ffffff;
  clear:both;
}

 .modal-body .message-sender-left {
  font-size: 12px;
  float:left;
  width: 25px;
  margin-right: 8px;
}
.modal-body .message-content-left {
  border-radius: 5px;
  margin-bottom: 5px;
  float:left;
  text-align: left;
  width: 450px;
}

.modal-body .message-content-left img{
  max-width: 450px;
}

.modal-body .message-content-left span { 
  padding: 5px 10px;
  background-color: #ece8e8;
  border-radius: 5px;
  display:inline-block;
  max-width: 450px;
  text-align: left;
}
 

.modal-body .message-sender-right {
  font-size: 12px;
  width: 25px;
  float: right;
  margin-left: 8px;
}
.modal-body .message-content-right { 
  border-radius: 5px;
  margin-bottom: 5px;
  text-align: right;
  width: 450px;
  float: right;
}

.modal-body .message-content-right img
{
  max-width: 450px;
}

.modal-body .message-content-right span { 
    padding: 5px 10px;
    background-color: #63f594;
    border-radius: 5px;
    display:inline-block;
    max-width: 450px;
    text-align: left;
}

.modal-body .chat-message .message-sender-right  img
{
   width: 30px;
   height: 30px;
   border-radius: 5px;
}

.modal-body .chat-message .message-sender-left img
{
   width: 30px;
   height: 30px;
   border-radius: 5px;
}

.modal-footer
{
  max-height: 150px;
  min-height: 150px;
}

.modal-footer .sendMsg
{
  width: 100%;
  height: 120px;
  min-height: 120px;
  overflow-y: auto;
  padding: 5px 5px;
  text-align: left;
  border: 1px solid #999999;
}
.el-dialog__footer
{
  padding-top:10px !important;
  border-top: 1px solid #dcdfe6
}
.modal-body .message-content-right .sendTime, .modal-body .message-content-left .sendTime
{
  padding: 5px 10px !important;
  background-color: transparent;
  font-size: 10px;
}
.uploadImage
{
  width: 20px;
  height: 20px;
}
.avatar-uploader .el-upload
{
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// Consult.vue?62004a5f